import { useQuery } from '@tanstack/react-query';
import useGetMarketingData from './useGetMarketingData';
import { getCampaignMetrics } from '../../services/marketing';

function useGetCampaignMetrics(campaignId: string | null) {
  const { data: marketingData, isFetching: isFetchingMarketing } =
    useGetMarketingData();

  const marketingBusinessId = marketingData?.id;

  const { data, isFetching, isLoading, isError, error, isSuccess, refetch } =
    useQuery({
      queryKey: ['campaign-metrics', marketingBusinessId, campaignId],
      queryFn: () => getCampaignMetrics(marketingBusinessId!, campaignId!),
      enabled: !!marketingBusinessId && !!campaignId && !isFetchingMarketing,
      placeholderData: undefined,
    });

  return { data, isFetching, isLoading, isError, error, isSuccess, refetch };
}

export default useGetCampaignMetrics;
